// 登录回跳目标（redirect）的统一编码/解析工具。
//
// 约定：redirect 参数值为「{ path, query }」JSON 经 encodeURIComponent 编码后的字符串，
// 由所有跳转登录页的入口（路由守卫 / logout / syncProfile / 改密码）统一生成，
// 登录页统一解析，保证微信/企微整页 OAuth 跳转后仍能恢复目标页面。
// 同时兼容历史遗留的裸路径字符串格式（如 EditPassword 旧代码写入的 '/xxx'）。

// 将回跳目标编码为 redirect 参数值（调用方放入 vue-router 的 query.redirect 即可）
export function encodeRedirect(path, query = {}) {
  if (!path) return '';
  return encodeURIComponent(JSON.stringify({ path, query }));
}

// 解析 URL 上的 redirect 参数值，返回 { path, query }；无法解析时返回 null。
// 兼容三种格式：
//   1. 双层编码 JSON（经 vue-router push 写入，URL 上是 %257B 形态）
//   2. 单层编码 JSON（直接写入 URL，如微信回调携带的 redirect_uri）
//   3. 裸路径字符串（历史遗留写法）
export function parseRedirect(redirectStr) {
  if (!redirectStr) return null;

  // 先尝试解码一次（无 % 编码时原样返回）
  let raw = redirectStr;
  try {
    raw = decodeURIComponent(redirectStr);
  } catch (e) {
    // 非法 % 序列，保持原值
  }

  // 尝试解析为 JSON 对象
  let parsed = null;
  try {
    parsed = JSON.parse(raw);
  } catch (e) {
    try {
      parsed = JSON.parse(redirectStr);
    } catch (e2) {
      parsed = null;
    }
  }

  if (parsed === null) {
    // 非 JSON：按裸路径字符串处理
    return { path: redirectStr, query: {} };
  }

  if (typeof parsed === 'string') {
    return { path: parsed, query: {} };
  }

  if (parsed && typeof parsed === 'object' && typeof parsed.path === 'string') {
    return { path: parsed.path, query: parsed.query || {} };
  }

  return null;
}
